import React, { useEffect, useState } from 'react';
import {
  PieChart, Pie, Cell,
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const Dashboard = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch('https://randomuser.me/api/?results=1000')
      .then(res => res.json())
      .then(data => {
        const formatted = data.results.map(user => ({
          name: `${user.name.first} ${user.name.last}`,
          age: user.dob.age,
          gender: user.gender === 'male' ? 'Male' : 'Female',
          status: getRandomStatus(),
        }));
        setUsers(formatted);
      })
      .catch(err => console.error('Error fetching users:', err));
  }, []);

  const getRandomStatus = () => {
    const statuses = ['ACTIVE', 'INACTIVE', 'DISABLED'];
    return statuses[Math.floor(Math.random() * statuses.length)];
  };

  // Filtered Users by search
  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );

  // Prepare chart data
  const countByStatus = {};
  const countByGender = {};

  users.forEach(user => {
    countByStatus[user.status] = (countByStatus[user.status] || 0) + 1;
    countByGender[user.gender] = (countByGender[user.gender] || 0) + 1;
  });

  return (
    <div className="page-container">
      <h2>📊 Admin Dashboard</h2>
      <p>Total Users: {users.length}</p>

      {/* 🔍 Search Bar */}
      <input
        type="text"
        placeholder="Search by name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          padding: '0.5rem',
          width: '100%',
          maxWidth: '400px',
          marginBottom: '1rem',
          borderRadius: '8px',
          border: '1px solid #ccc',
          fontSize: '1rem'
        }}
      />

      {/* 📋 User Table */}
      <div className="table-container">
        <table className="user-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Age</th>
              <th>Gender</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{user.name}</td>
                <td>{user.age}</td>
                <td>{user.gender}</td>
                <td>{user.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 📊 Pie Chart - Status */}
      <h3 style={{ marginTop: '2rem' }}>📌 Status Distribution</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={Object.entries(countByStatus).map(([name, value]) => ({ name, value }))}
            dataKey="value"
            nameKey="name"
            outerRadius={100}
            label
          >
            {Object.entries(countByStatus).map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA66CC'][index % 5]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      {/* 📊 Bar Chart - Gender */}
      <h3>📌 Gender Breakdown</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={Object.entries(countByGender).map(([name, value]) => ({ name, value }))}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="value" fill="#00C49F" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Dashboard;
